import { ref, computed, onMounted, onUnmounted } from 'vue';
// @ts-ignore
import CSSBreakpoints from '~/assets/_scss/_utils/variables.scss';

const ticketBreak = parseInt(CSSBreakpoints.ticketBreak, 10);
// Vuetify's own `xs` ceiling. The SCSS map has no 600px entry, and its `xs`
// (480px) is a different breakpoint, so hardcoding keeps `xsOnly` a drop-in too.
const vuetifyXsMax = 600;

/**
 * Tracks viewport width against the SCSS breakpoints, replacing
 * $vuetify.breakpoint. `ticketBreak` (1264px) matches Vuetify's own default
 * `mdAndDown` threshold exactly, so this is a drop-in replacement.
 */
export function useBreakpoint() {
  const width = ref(process.client ? window.innerWidth : 0);

  function updateWidth() {
    width.value = window.innerWidth;
  }

  onMounted(() => {
    window.addEventListener('resize', updateWidth);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
  });

  return {
    width,
    xsOnly: computed(() => width.value < vuetifyXsMax),
    mdAndDown: computed(() => width.value < ticketBreak)
  };
}
